// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"38439a45","453":"8d037e3b"}[chunkId] + ".chunk.js";
};